<template>
  <div>
    <md-field :class="getValidationClass('diametroDaValvula')">
      <label for="diametroDaValvula">Diâmetro da Válvula (mm)</label>
      <md-input
        v-model.number="valvula.diametroDaValvula"
        type="number"
        @change="handleChange"
      />
      <span v-if="!$v.valvula.diametroDaValvula.required" class="md-error">
        Diâmetro da Válvula é obrigatório
      </span>
    </md-field>

    <md-field>
      <label for="modeloDaValvula">Modelo da Válvula</label>
      <md-select
        id="modeloDaValvula"
        v-model="valvula.modeloDaValvula"
        name="modeloDaValvula"
        @md-selected="handleChange"
      >
        <md-option value="Globo"> Globo </md-option>
        <md-option value="Gaveta"> Gaveta </md-option>
        <md-option value="VRP"> VRP </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
    </md-field>

    <md-field v-if="valvula.modeloDaValvula === 'Outro'">
      <label for="modeloDaValvulaOutro">Especificar o Modelo da Válvula</label>
      <md-input v-model="valvula.modeloDaValvulaOutro" @change="handleChange" />
    </md-field>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FormularioValvulaSig',
  mixins: [validationMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      valvula: {
        diametroDaValvula: null,
        modeloDaValvula: 'Globo',
        modeloDaValvulaOutro: null,
      },
    }
  },
  validations: {
    valvula: {
      diametroDaValvula: { required },
      modeloDaValvula: {},
      modeloDaValvulaOutro: {},
    },
  },
  beforeMount() {
    if (this.data) {
      this.valvula = { ...this.data }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.valvula[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleChange() {
      this.$v.$touch()

      this.$forceUpdate()

      this.$emit('change', {
        isValid: !this.$v.$invalid,
        data: { ...this.valvula },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
